module.exports = __webpack_public_path__ + "img/0D.0bd53a64.png";